import { SvgProps } from "./Form";

export const SparkleGreyOutlined = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.0905 7.67897L12.2732 7.15964C11.4548 6.92891 10.7093 6.49202 10.108 5.89077C9.50679 5.28952 9.0699 4.54403 8.83918 3.72564L8.31984 1.9083C8.29373 1.84472 8.2493 1.79034 8.1922 1.75207C8.1351 1.71379 8.06791 1.69336 7.99918 1.69336C7.93044 1.69336 7.86325 1.71379 7.80616 1.75207C7.74906 1.79034 7.70463 1.84472 7.67851 1.9083L7.15918 3.72564C6.92845 4.54403 6.49156 5.28952 5.89031 5.89077C5.28906 6.49202 4.54357 6.92891 3.72518 7.15964L1.90784 7.67897C1.83806 7.69878 1.77665 7.7408 1.73292 7.79867C1.68919 7.85655 1.66553 7.9271 1.66553 7.99964C1.66553 8.07217 1.68919 8.14273 1.73292 8.2006C1.77665 8.25847 1.83806 8.3005 1.90784 8.3203L3.72518 8.83964C4.54357 9.07037 5.28906 9.50726 5.89031 10.1085C6.49156 10.7098 6.92845 11.4552 7.15918 12.2736L7.67851 14.091C7.69832 14.1608 7.74034 14.2222 7.79821 14.2659C7.85608 14.3096 7.92664 14.3333 7.99918 14.3333C8.07171 14.3333 8.14227 14.3096 8.20014 14.2659C8.25801 14.2222 8.30004 14.1608 8.31984 14.091L8.83918 12.2736C9.0699 11.4552 9.50679 10.7098 10.108 10.1085C10.7093 9.50726 11.4548 9.07037 12.2732 8.83964L14.0905 8.3203C14.1603 8.3005 14.2217 8.25847 14.2654 8.2006C14.3092 8.14273 14.3328 8.07217 14.3328 7.99964C14.3328 7.9271 14.3092 7.85655 14.2654 7.79867C14.2217 7.7408 14.1603 7.69878 14.0905 7.67897Z"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
    />
  </svg>
);
